export default class Quizz {
  constructor(el) {
    this.formError = false;
    this.formEl = el;
    this.onFormSubmit = this.onFormSubmit.bind(this);

    if (this.formEl) {
      this.formEl.addEventListener("submit", this.onFormSubmit);
    }
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.formError = false;

    const captchaResponse = grecaptcha.getResponse()

    if (!captchaResponse) {
      this.formEl.querySelector('[data-captcha-required]').style.display = 'block'
      return;
    } else {
      this.formEl.querySelector('[data-captcha-required]').style.display = 'none'
    }

    let score = 0;
    const answers = [];
    const questionsCollection = this.formEl.querySelectorAll("[data-question]");

    // Iterate over question, create an array of objects with question label + anwer label
    // Use the same loop to compute total score
    questionsCollection.forEach((el) => {
      const questionLabelEl = el.querySelector("[data-question-label]");
      const checkedInput = el.querySelector('input[type="radio"]:checked');
      const answerLabelEl = el.querySelector(
        `label[for="${checkedInput.getAttribute("id")}"]`
      );

      answers.push({
        label: questionLabelEl.textContent,
        value: answerLabelEl.textContent,
      });

      if (checkedInput && checkedInput.getAttribute("value") === "yes") {
        const points = parseInt(el.getAttribute("data-question-score"), 10);
        score += points;
      }
    });

    // Determinate level of risk based on total score
    let level = "low";
    if (score >= 3 && score < 5) {
      level = "moderate";
    } else if (score >= 5) {
      level = "high";
    }

    const data = {
      responsable: {
        "responsable-firstname": this.formEl.querySelector(
          "[name='responsable-firstname']"
        ).value,
        "responsable-lastname": this.formEl.querySelector(
          "[name='responsable-lastname']"
        ).value,
        "responsable-email": this.formEl.querySelector(
          "[name='responsable-email']"
        ).value,
      },
      project: {
        "project-partners": this.formEl.querySelector(
          "[name='project-partners']"
        ).value,
        "project-country": this.formEl.querySelector("[name='project-country']")
          .value,
        "project-duration": this.formEl.querySelector(
          "[name='project-duration']"
        ).value,
      },
      answers,
      score: {
        score,
        level,
      },
      'g-recaptcha-response': captchaResponse
    };

    axios.post("http://uliege.api.v1.staging.epic-sys.io/api/v1/form/", JSON.stringify(data), {
        headers: {
            'Content-Type': 'application/json',
        }
      }
    )
    .catch(() => {
      this.formError = true
      document.querySelector('[data-form-error]').style.display = 'block'
    })
    .then(() => {
      if (!this.formError) {
        this.updateUI(score)
      }
    });
  }

  updateUI(score) {
    this.formEl.style.display = "none";

    let resultsElSelector = "[data-quizz-results-low]";
    if (score >= 3 && score < 5) {
      resultsElSelector = "[data-quizz-results-moderate]";
    } else if (score >= 5) {
      resultsElSelector = "[data-quizz-results-high]";
    }
    const resultsEl = document.querySelector(resultsElSelector);
    if (resultsEl) {
      const scoreEl = resultsEl.querySelector("[data-quizz-results-score]");
      if (scoreEl) {
        scoreEl.innerHTML = score;
      }

      resultsEl.style.display = "block";
    }
  }
}
